/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*****************************!*\
  !*** ./src/js/ai-search.js ***!
  \*****************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
//import { levenshtein } from './levenshtein';
//import { synonyms } from './synonyms';
// function findSynonyms(query) {
//     return Object.keys(synonyms).flatMap(key => {
//         if (key.toLowerCase().startsWith(query.toLowerCase())) {
//             return synonyms[key];
//         }
//         return [];
//     });
// }
function stripParameters(url) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://crepslocker.com';
  if (!url || typeof url !== 'string') {
    return url; // Return original URL if it's not valid
  }

  try {
    var urlObj = new URL(url, baseUrl);
    urlObj.searchParams["delete"]('_pos');
    urlObj.searchParams["delete"]('_sid');
    urlObj.searchParams["delete"]('_ss');
    urlObj.searchParams["delete"]('variant'); // Add this line to remove the variant parameter
    return urlObj.toString();
  } catch (error) {
    console.error("Error stripping parameters:", error);
    return url; // If there's an error, return the original URL
  }
}
var LiveSearch = /*#__PURE__*/function () {
  function LiveSearch(_ref) {
    var _this = this;
    var input = _ref.input,
      suggestions = _ref.suggestions,
      resultsContainer = _ref.resultsContainer,
      searchUrl = _ref.searchUrl,
      _ref$debounceTime = _ref.debounceTime,
      debounceTime = _ref$debounceTime === void 0 ? 250 : _ref$debounceTime;
    _classCallCheck(this, LiveSearch);
    this.input = input;
    this.resultsContainer = resultsContainer;
    this.searchUrl = searchUrl;
    this.debounceTime = debounceTime;
    this.searchWrapper = document.querySelector('#search-wrapper');
    this.preSearch = document.querySelector('#presearch');
    this.noResults = document.querySelector('#no-results-msg');
    this.noResultsTerm = document.querySelector('#no-results-term');
    this.suggestions = suggestions || [];
    this.suggestionsContainer = document.getElementById('suggestions-container');
    //this.trendingContainer = document.getElementById('trending-container');
    this.paginationContainer = document.querySelector('.pagination-container');
    this.searchUrl = '/search?query=';
    // this.voiceSearchButton = document.getElementById('voice-search');
    // this.voiceSearchButton.addEventListener('click', () => this.startVoiceSearch());
    this.searchModal = document.querySelector('[data-live-search]');
    this.toggleButtons = document.querySelectorAll('[data-search-toggle]');
    this.bindToggleButtons();
    this.closeButton = document.querySelector('#close-results');
    this.searchInfo = document.querySelector('#search-info');
    this.closeButton.addEventListener('click', function () {
      _this.hideModal();
    });
    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', this.debounce(this.onChange, debounceTime).bind(this));
    }
    input.addEventListener('focus', function () {
      var query = input.value.trim();
      _this.searchWrapper.classList.remove('hidden');
      if (!input.value.trim()) {
        //this.trendingContainer.classList.remove('hidden');
      }
      if (query.length >= 1) {
        _this.search(query);
      }
    });
    var selectedIndex = -1;
    this.input.addEventListener('keydown', function (event) {
      var results = _this.resultsContainer.querySelectorAll('.search-result');
      var maxIndex = results.length - 1;
      if (event.key === 'ArrowDown') {
        selectedIndex = Math.min(selectedIndex + 1, maxIndex);
        _this.highlightResult(selectedIndex);
      } else if (event.key === 'ArrowUp') {
        selectedIndex = Math.max(selectedIndex - 1, -1);
        _this.highlightResult(selectedIndex);
      } else if (event.key === 'Enter' && selectedIndex >= 0) {
        event.preventDefault();
        var selectedResult = results[selectedIndex];
        if (selectedResult) {
          window.location.href = selectedResult.href;
        }
      }
    });
  }
  _createClass(LiveSearch, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.searchInput.addEventListener('input', function (e) {
        return _this2.search(e.target.value);
      });
    }
  }, {
    key: "bindToggleButtons",
    value: function bindToggleButtons() {
      var _this3 = this;
      if (this.toggleButtons.length > 0) {
        this.toggleButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            _this3.toggleSearchModal();
          });
        });
      } else {
        console.error('No elements found with data-search-toggle attribute');
      }
    }
  }, {
    key: "createOverlay",
    value: function createOverlay() {
      var _this4 = this;
      var overlay = document.createElement('div');
      overlay.classList.add('search-overlay', 'fixed', 'inset-0', 'w-full', 'h-full', 'bg-black/30', 'z-[300]', 'transition-all');
      overlay.addEventListener('click', function () {
        return _this4.hideModal();
      });
      return overlay;
    }
  }, {
    key: "onFormReset",
    value: function onFormReset() {
      this.input.value = '';
      this.hideResults();
      document.querySelector('#resetButton').classList.add('hidden');
      // Add any other behavior you want on form reset
    }
  }, {
    key: "onChange",
    value: function onChange(event) {
      var query = event.target.value.trim();
      if (query.length > 0) {
        //this.showHints(query);
        this.searchWrapper.classList.remove('hidden');
        document.querySelector('#resetButton').classList.remove('hidden');
      } else {
        //this.searchWrapper.classList.add('hidden');
        this.hideResults();
        //console.log('search length 0');
        document.querySelector('#resetButton').classList.add('hidden');
      }
      if (query.length < 1) {
        this.hideResults();
        return;
      }
      this.search(query);
    }
  }, {
    key: "toggleSearchModal",
    value: function toggleSearchModal() {
      var _this5 = this;
      this.searchModal.classList.toggle('active');
      document.body.classList.toggle('search-active');
      this.preSearch.classList.remove('hidden');
      if (this.searchModal.classList.contains('active')) {
        setTimeout(function () {
          //console.log('focusing input');
          _this5.input.focus();
        }, 200);
        // Append overlay to body
        //this.trendingContainer.classList.remove('hidden');
        document.body.appendChild(this.createOverlay());
      } else {
        //this.trendingContainer.classList.add('hidden');
        // Remove overlay from body
        var overlay = document.querySelector('.search-overlay');
        if (overlay) overlay.remove();
      }
    }
  }, {
    key: "highlightResult",
    value: function highlightResult(index) {
      var results = this.resultsContainer.querySelectorAll('.search-result');
      results.forEach(function (result, i) {
        if (i === index) {
          result.classList.add('border-yellow-500');
        } else {
          result.classList.remove('border-yellow-500');
        }
      });
    }
  }, {
    key: "debounce",
    value: function debounce(func, wait) {
      var timeout;
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var context = this;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          return func.apply(context, args);
        }, wait);
      };
    }

    // showHints(query) {
    //     // const filteredSuggestions = this.suggestions.filter(suggestion =>
    //     //     suggestion.toLowerCase().startsWith(query.toLowerCase())
    //     // );

    //     const synonymSuggestions = findSynonyms(query);
    //     const allSuggestions = [...synonymSuggestions];

    //     const suggestionItems = allSuggestions
    //         .map(
    //             suggestion => `<div class="text-black text-[12px] cursor-pointer hover:underline leading-none pb-1">${suggestion}</div>`
    //         )
    //         .join('');

    //     if (allSuggestions.some(suggestion => suggestion.toLowerCase() === query.toLowerCase())) {
    //         this.suggestionsContainer.innerHTML = '';
    //     } else {
    //         this.suggestionsContainer.innerHTML = suggestionItems;
    //     }

    //     const suggestionElements = this.suggestionsContainer.querySelectorAll('div');
    //     suggestionElements.forEach(element => {
    //         element.addEventListener('click', event => {
    //             this.input.value = event.target.textContent;
    //             this.suggestionsContainer.innerHTML = '';
    //             this.search(event.target.textContent);
    //         });
    //     });
    // }
  }, {
    key: "updatePaginationActiveState",
    value: function updatePaginationActiveState(activePage) {
      this.paginationContainer.querySelectorAll('.pagination-btn').forEach(function (btn) {
        var page = parseInt(btn.dataset.page, 5);
        if (page === activePage) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    }
  }, {
    key: "search",
    value: function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(query) {
        var page,
          searchUrl,
          response,
          data,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
              if (!(query.length > 0)) {
                _context.next = 18;
                break;
              }
              _context.prev = 2;
              searchUrl = "/search?q=".concat(encodeURIComponent(query), "&page=").concat(page, "&view=json"); // console.log(searchUrl);
              _context.next = 6;
              return fetch(searchUrl);
            case 6:
              response = _context.sent;
              _context.next = 9;
              return response.json();
            case 9:
              data = _context.sent;
              this.displayResults(data);
              // console.log(data);
              // console.log(window.routes.predictive_search_url)
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              console.error('Error fetching search data:', _context.t0);
            case 16:
              _context.next = 19;
              break;
            case 18:
              this.resultsContainer.innerHTML = '';
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 13]]);
      }));
      function search(_x) {
        return _search.apply(this, arguments);
      }
      return search;
    }() // expandQueryWithSynonyms(query) {
    //     const terms = query.split(' ');
    //     const expandedTerms = terms.flatMap(term => synonyms[term.toLowerCase()] || term);
    //     return expandedTerms.join(' ');
    // }
  }, {
    key: "startVoiceSearch",
    value: function startVoiceSearch() {
      var _this6 = this;
      if (!('webkitSpeechRecognition' in window)) {
        alert('Your browser does not support voice search. Please try using Google Chrome.');
        return;
      }
      var recognition = new webkitSpeechRecognition();
      recognition.lang = 'en-US';
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;
      recognition.onresult = function (event) {
        var speechResult = event.results[0][0].transcript;
        _this6.input.value = speechResult;
        _this6.input.dispatchEvent(new Event('input'));
      };
      recognition.onerror = function (event) {
        console.error('Error occurred in recognition:', event.error);
      };
      recognition.start();
    }

    // Improved Levenshtein algorithm for more accurate search results
  }, {
    key: "modifiedLevenshtein",
    value: function modifiedLevenshtein(a, b) {
      var matrix = [];
      var searchTerm = a.toLowerCase();
      var title = b.toLowerCase();

      // Check for exact match first
      if (title.includes(searchTerm)) {
        // Split the title and search term into words
        var titleWords = title.split(/\s+/);
        var searchTermWords = searchTerm.split(/\s+/);

        // Check if all words in the search term are present as whole words in the title
        var allWordsMatch = true;
        var _iterator = _createForOfIteratorHelper(titleWords),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var word = _step.value;
            if (!searchTermWords.includes(word)) {
              allWordsMatch = false;
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (allWordsMatch) {
          console.log('ALL WORDS MATCH');
          return 0; // Return 0 if all words in the search term match whole words in the title
        }
      }

      // Initialize the matrix
      for (var i = 0; i <= b.length; i++) {
        matrix[i] = [i];
      }
      for (var j = 0; j <= a.length; j++) {
        matrix[0][j] = j;
      }

      // Populate the rest of the matrix
      for (var _i = 1; _i <= b.length; _i++) {
        for (var _j = 1; _j <= a.length; _j++) {
          if (b.charAt(_i - 1) === a.charAt(_j - 1)) {
            matrix[_i][_j] = matrix[_i - 1][_j - 1];
          } else {
            matrix[_i][_j] = Math.min(matrix[_i - 1][_j - 1] + 1,
            // substitution
            Math.min(matrix[_i][_j - 1] + 1,
            // insertion
            matrix[_i - 1][_j] + 1)); // deletion
          }
        }
      }

      return matrix[b.length][a.length];
    }
  }, {
    key: "displayResults",
    value: function displayResults(data) {
      var _this7 = this;
      this.resultsContainer.classList.remove('hidden');
      //console.log('hide presearch / show results');
      this.preSearch.classList.add('hidden');
      var resultsCount = data.results_count || 0;
      var terms = data.terms;
      var results = data.results || [];
      //console.log(results);
      var collections = data.collections || [];
      var products = results.filter(function (result) {
        return result.object_type == 'product';
      });
      var pages = results.filter(function (result) {
        return result.object_type === 'page';
      });
      var articles = results.filter(function (result) {
        return result.object_type === 'article';
      });
      var matchingCollections = '';
      if (terms) {
        var searchTerm = terms.toLowerCase();
        products = products.map(function (product) {
          var distance = _this7.modifiedLevenshtein(searchTerm, product.title.toLowerCase());
          //console.log(product);
          return _objectSpread(_objectSpread({}, product), {}, {
            _distance: distance
          });
        }).sort(function (a, b) {
          return a._distance - b._distance;
        });
        pages = pages.filter(function (page) {
          return page.title.toLowerCase().includes(searchTerm);
        });
        articles = articles.filter(function (article) {
          return article.title.toLowerCase().includes(searchTerm);
        });
        matchingCollections = collections.filter(function (collection) {
          return collection.title.toLowerCase().includes(searchTerm);
        });

        // use levenstein to sort the collection array also
        matchingCollections = matchingCollections.map(function (collection) {
          var distance = _this7.modifiedLevenshtein(searchTerm, collection.title.toLowerCase());
          return _objectSpread(_objectSpread({}, collection), {}, {
            _distance: distance
          });
        }).sort(function (a, b) {
          return a._distance - b._distance;
        });
        console.log(matchingCollections);
      } else {
        matchingCollections = collections;
      }
      // filter products to not include items with tag or title of damaged here, and slice that below instead?
      var filteredProducts = products.filter(function (product) {
        return !product.content.toLowerCase().includes('<!--if-->');
      });
      var limitedProducts = filteredProducts.slice(0, 18);
      var limitedcollections = matchingCollections.slice(0, 20);

      // collection synonyms
      // collections dont have access to synonyms, so we check if collection titles are contained in any of the product titles (that DO include synonyms results.)
      if (terms) {
        if (limitedcollections.length < 20) {
          var neededAdditions = 20 - limitedcollections.length;
          var additionalCollections = new Set(limitedcollections.map(function (col) {
            return col.title.toLowerCase();
          }));
          limitedProducts.every(function (product) {
            if (limitedcollections.length >= 20) {
              return false; // Exit the 'every' loop
            }

            var productTitle = product.title.toLowerCase();
            collections.some(function (collection) {
              var collectionTitle = collection.title.toLowerCase().replace(/\btrainers\b/, '').trim();
              if (productTitle.includes(collectionTitle) && !additionalCollections.has(collectionTitle)) {
                additionalCollections.add(collectionTitle);
                limitedcollections.push(collection); // Add the collection to limitedcollections
                return limitedcollections.length >= 20; // Exit the 'some' loop if enough collections are added
              }

              return false;
            });
            return true; // Continue the 'every' loop
          });

          // Remove duplicates from limitedcollections at the end
          limitedcollections = Array.from(new Set(limitedcollections));
        }
      }
      var collectionResults = this.formatResults(limitedcollections, 'Collection');
      var productResults = this.formatResults(limitedProducts, 'Product');
      //const collectionResults = this.formatResults(limitedcollections, 'Collection'); // Modify this line
      var pageResults = this.formatResults(pages, 'Page');
      var articleResults = this.formatResults(articles, 'Article');

      //handle single and no collection results
      var gridCols = limitedcollections.length == 1 ? 'grid-cols-1' : 'grid-cols-2';
      var noResultsHide = limitedcollections.length < 1 ? 'hidden lg:grid' : '';
      var noCollectionFound = limitedcollections.length < 1 ? "<p class=\"text-[13px]\">No collections matching your search</p>" : '';
      if (resultsCount === 0 || !this.input.value.trim()) {
        //if no results or search is only spaces
        //this.trendingContainer.classList.remove('hidden');
        //this.resultsContainer.classList.add('hidden');
        this.noResults.classList.remove('hidden');
        //this.noResultsTerm.innerText = terms;
        this.noResultsTerm.innerText = new DOMParser().parseFromString(terms, "text/html").documentElement.textContent;
        this.hideResults();
      } else {
        //if there are results
        //this.trendingContainer.classList.add('hidden');
        this.noResults.classList.add('hidden');
        this.noResultsTerm.innerText = '';
      }
      this.resultsContainer.innerHTML = "\n            <div class=\"grid grid-cols-1 lg:grid-cols-8 lg:pt-2 gap-x-4\">\n                <div class=\"lg:col-span-2\">\n                    <div class=\"w-full\">\n                        <div class=\"search-section p-3 rounded-xl bg-[#fafafa] grid ".concat(gridCols, " lg:grid-cols-1 gap-x-2 mb-2 ").concat(noResultsHide, "\">\n                            <h3 class=\"text-sm font-bold uppercase mb-2 col-span-2 lg:col-span-1\">Collections</h3>\n                            ").concat(noCollectionFound, "\n                            ").concat(collectionResults.join(''), "\n                        </div>\n                        <div class=\"search-section pb-2 hidden\">\n                            <h3 class=\"text-sm font-bold uppercase mb-2\">Articles</h3>\n                            ").concat(articleResults.join(''), "\n                        </div>\n                        <div class=\"search-section pb-2 hidden\">\n                            <h3 class=\"text-sm font-bold uppercase mb-2\">Pages</h3>\n                            ").concat(pageResults.join(''), "\n                        </div>\n                    </div>\n                </div>\n                <div class=\"lg:col-span-6 \">\n                    <div class=\"w-full\">\n                        <div class=\"search-section\">\n                            <div class=\"flex items-center w-full mb-2 gap-x-2\"><h3 class=\"text-sm uppercase\"><strong>Products</strong> <span class=\"text-gray-500\">for '").concat(terms, "'</span></h3><div class=\"bg-gray-300 h-[1px] grow\"></div></div>\n                            <div class=\"grid grid-cols-4 lg:grid-cols-6 gap-x-4 gap-y-4\">\n                                ").concat(productResults.join(''), "\n                            </div>\n                            <a class=\"block text-[12px] text-gray-500 mt-5\" href=\"/search?q=").concat(encodeURIComponent(terms), "\">View all ").concat(resultsCount, " results for \"").concat(terms, "\"</a>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ");
    }
  }, {
    key: "hideModal",
    value: function hideModal() {
      document.body.classList.remove('search-active');
      //this.trendingContainer.classList.add('hidden');
      this.searchModal.classList.remove('active');
      this.preSearch.classList.remove('hidden');
      this.input.value = '';
      this.input.blur();
      this.hideResults();

      // Remove overlay from body
      var overlay = document.querySelector('.search-overlay');
      if (overlay) overlay.remove();
    }
  }, {
    key: "hideResults",
    value: function hideResults() {
      //this.searchWrapper.classList.add('hidden');
      this.resultsContainer.classList.add('hidden');
      this.preSearch.classList.remove('hidden');
      //this.trendingContainer.classList.add('hidden');
    }
  }, {
    key: "checkForTag",
    value: function checkForTag(title) {
      var pattern = /\(W\)|\(GS\)|\(PS\)|\(TD\)/;
      var match = title.match(pattern);
      return match ? match[0] : null;
    }
  }, {
    key: "formatResults",
    value: function formatResults(items, type) {
      var _this8 = this;
      var searchTerm = this.input.value.trim().toLowerCase();
      return items.map(function (item) {
        var title = item.title;
        var type_tag = _this8.checkForTag(title);
        var typeTagDiv = '';
        if (type_tag) {
          //typeTagDiv = `<div class="h-full bg-white pl-1"><span class="font-bold">${type_tag}</span></div>`;
          title = title.replace(type_tag, '').trim(); //remove the tag from the title if there is one
          title = type_tag + " " + title;
        }
        item.url = stripParameters(item.url);
        if (searchTerm) {
          var index = title.toLowerCase().indexOf(searchTerm);
          if (index !== -1) {
            title = "".concat(title.slice(0, index), "<span class=\"highlight font-bold\">").concat(title.slice(index, index + searchTerm.length), "</span>").concat(title.slice(index + searchTerm.length));
          }
        }

        // //logic to span 2 col if only one collection result
        // let colSpanClass = '';
        // if (type == 'Collection' && items.length < 1) {
        //     console.log('One collection found');
        //     let colSpanClass = array.length === 1 ? 'col-span-2' : '';
        // }

        if (type === 'Product') {
          return "\n                <div class=\"search-result product-result border border-transparent\">\n                    <a href=\"".concat(item.url, "\" class=\"flex flex-col\">\n                        ").concat(item.image ? "<img src=\"".concat(item.image, "&width=300\" alt=\"").concat(item.title, "\" width=\"180\" height=\"180\" class=\"w-full h-auto object-cover\">") : '', "\n                        <div class=\"w-full flex text-[13px] leading-none py-1 items-center justify-start\">\n                            <p class=\"shrink line-clamp-2 lg:line-clamp-1 leading-tight\">").concat(title, "</p>\n                        </div>\n                    </a>\n                </div>");
        } else {
          return "\n                <div class=\"search-result other-result border border-transparent\">\n                    <a href=\"".concat(item.url, "\" class=\"block font-normal text-[13px] leading-none hover:underline pb-2 mb-1 truncate\"> ").concat(title, "</a>\n                </div>");
        }
      });
    }
  }]);
  return LiveSearch;
}();
var liveSearch = new LiveSearch({
  input: document.getElementById('search-input'),
  resultsContainer: document.getElementById('results-container'),
  searchUrl: '/search?q=view=results'
});
/******/ })()
;